export default __webpack_public_path__ + "static/media/icon-aprovado.6d3ebf69.svg";